import { useEffect, useRef } from 'react';
import { usePlaybackStore } from '../../store/playbackStore';

export function TimelinePlayhead({ zoom, labelWidth }: { zoom: number; labelWidth: number }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => usePlaybackStore.subscribe((state) => { if (ref.current) ref.current.style.transform = `translateX(${labelWidth + state.currentTime * zoom}px)`; }), [labelWidth, zoom]);
  const initial = usePlaybackStore.getState().currentTime;
  return <div ref={ref} className="timeline-playhead" style={{ transform: `translateX(${labelWidth + initial * zoom}px)` }}><span /><i /></div>;
}
